module.exports = __webpack_public_path__ + "img/valores-time.bc0a0261.svg";